// extracted by mini-css-extract-plugin
export default {"container":"Upsell_container__cUX6e","title":"Upsell_title__q8DAt","buttons":"Upsell_buttons__3hQmr"};